let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("iI4Mf")), load("hBF5o")]).then(() => parcelRequire('jIXzu'));